import { render, staticRenderFns } from "./Posting.vue?vue&type=template&id=a5ba8954&scoped=true"
import script from "./Posting.vue?vue&type=script&lang=js"
export * from "./Posting.vue?vue&type=script&lang=js"
import style0 from "./Posting.vue?vue&type=style&index=0&id=a5ba8954&prod&scoped=true&lang=css"
import style1 from "./Posting.vue?vue&type=style&index=1&id=a5ba8954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba8954",
  null
  
)

export default component.exports